<template>
  <div :class="['custom-input', { 'is-focused': focused }]">
    <img v-if="iconPath" :src="iconPath" alt="Left Icon" class="left-icon" />
    <input
      v-bind="$attrs"
      :type="computedType"
      v-model="internalValue"
      @input="validateInput"
      @focus="focused = true"
      @blur="focused = false"
      class="input-field"
    />

    <span v-if="isPassword" @click="togglePassword" class="right-icon">
      <img
        :src="showPassword ? eyeOpenIcon : eyeClosedIcon"
        alt="Toggle Password Visibility"
        class="eye-icon"
      />
    </span>
  </div>
</template>

<script>
export default {
  name: "CustomInput",
  props: {
    value: String,
    type: {
      type: String,
      default: "text",
    },
    iconPath: {
      type: String,
      // required: true,
      default: null,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      internalValue: this.value,
      showPassword: false,
      focused: false,
      eyeOpenIcon: require("@/assets/icons/eyeopen.png"),
      eyeClosedIcon: require("@/assets/icons/eyeclosed.png"),
    };
  },
  computed: {
    isPassword() {
      return this.type === "password";
    },
    computedType() {
      return this.isPassword && !this.showPassword ? "password" : "text";
    },
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
  },
  methods: {
    updateValue(event) {
      this.$emit("input", event.target.value);
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    validateInput(event) {
      this.updateValue(event);

      this.errorMessage = "";
      let isValid = true;

      for (const rule of this.rules) {
        const result = rule(this.internalValue);
        if (result !== true) {
          isValid = false;
          this.errorMessage = result;
          break;
        }
      }
      this.$emit("input", this.internalValue);
      this.$emit("valid", isValid);
      this.$emit("error-message", this.errorMessage);
    },
  },
};
</script>

<style scoped>
.custom-input {
  display: flex;
  align-items: center;
  border: none;
  border-radius: 8px;
  padding: 5px;
  margin-top: 6px;
  height: 42px;
  width: 400px;
  position: relative;
  background-color: rgba(99, 89, 120, 0.05);
  transition: background-color 0.3s ease, border 0.3s ease;
}

.custom-input.is-focused {
  background-color: transparent;
  border: 1px solid rgb(102, 9, 255);
}

.left-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  position: absolute;
  left: 8px;
}

.input-field {
  border: none;
  outline: none;
  padding-left: 35px;
  padding-right: 35px;
  flex: 1;
  height: 22px;
  width: 42px;
  background-color: transparent;
}
.custom-input:not(:has(img.left-icon)) .input-field {
  padding-left: 8px; /* Adjusted padding when no icon is present */
}
input:-webkit-autofill {
  background-color: transparent !important;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset !important; /* Forces white background */
  -webkit-text-fill-color: black !important; /* Ensures text color is not affected */
  transition: background-color 5000s ease-in-out 0s; /* Prevents flashing of yellow color */
}

.right-icon {
  position: absolute;
  right: 8px;
  cursor: pointer;
}

.eye-icon {
  margin-top: 6px;
  width: 20px;
  height: 20px;
}
</style>
